import React, { useState, useEffect } from 'react';
import Article from '../Article/Article';
import { Link } from 'react-router-dom';

const CursorPricingCaseStudy = () => {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch('/content/case-studies/cursor-pricing.md')
      .then(response => response.text())
      .then(text => setMarkdown(text));
  }, []);

  return (
    <Article
      markdown={markdown}
      callToAction={
        <Link to="/book-demo" className="btn btn-primary btn-lg btn-very-wide btn-square">
          Book a Demo
        </Link>
      }
    />
  );
};

export default CursorPricingCaseStudy; 